import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { ThumbnailService } from '../thumbnail.service';
import { LocationService } from '../location.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-vendor-order-edit',
  templateUrl: './vendor-order-edit.component.html',
  styleUrls: ['./vendor-order-edit.component.scss'],
})
export class VendorOrderEditComponent  {

  loader:boolean = true;
  showQty;
  cost;
  materialpop:boolean=false;
  showDiv:boolean=false;
  showAdd:boolean=true;
  cartView:boolean=false;
  cartload: boolean = false;
  storeObj:any=[];
  otherItem;
  itemsInOrder:any=[];
  filterData:any=[];
  itemTypeId;
  category;
  cateCode;
  search;
  name;
  purrchaseItems;
  delRegion;
  id;
  url;
Ind;
region;
orderId;
orderItems: any =[];
itemtypeObj:any=[];
ItemOrders:any=[];
typeName;
typeId;
amtLoader:boolean;
addition:boolean=false;
squareFeet:boolean=false;
slideOpts={
  loop:false,
  effect: 'slide',
  slidesPerView: 4,
  spaceBetween: 8
}
loader1:boolean;
toploader:boolean;
orderEditQty:any=[];
created:boolean=true;
saved:boolean=false;
matCost;
mixedbooking:boolean;
mixedvalue;
mixvalue;
typeConfirmPop:boolean;
itemname;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    private bottomSheet: MatBottomSheet, 
    public thumb:ThumbnailService,
    public auth: AuthService,
    public location: LocationService, 
    public app: AppComponent,
     public santinzer: DomSanitizer,
      public platform: Platform) { }

  ionViewWillEnter(){
    this.typeName = "ALL"
    this.url=window.location.href;
    this.getCategory();
    this.addition=false;
    this.cartView=false;
    this.materialpop=false;
    this.orderItems.orderAmountStr="";
    this.id=this.url.split('/').pop();
    this.orderId=sessionStorage.getItem('orderId')
    this.getOrderById()
   this.created=true;
    this.saved=false;
  }

  
getitemTypeInCreate(){
  this.service.getItemTypeByCategory(this.id).subscribe((res: any)=>{
    if(res){
      this.itemtypeObj= res;
      if(this.mixvalue){
        this.itemtypeObj.map(dat5=>{
          if(dat5.id==this.mixvalue){
            this.itemname=dat5;
          }
        })
      }
      this.itemtypeObj.map(res=>{
        if(res.id==this.itemTypeId){
          Object.assign(res,{highlight:true})
        }  
      })   
      this.itemtypeObj.map(dat1=>{
        Object.assign(dat1,{highlight:false})
      }) 
      this.itemtypeObj.map(dat2=>{
        if(dat2.docId){
          this.thumb.getThumbIcon1(dat2);
        }
      })
      if(this.cateCode!="CAR"){
        if(this.mixedbooking==false){
          this.otherItem = this.itemname;
          Object.assign(this.otherItem,{highlight:true})
          this.routeToItems(this.otherItem) 
        }else{
        this.otherItem = this.itemtypeObj[0];
        Object.assign(this.otherItem,{highlight:true})
        this.routeToItems(this.otherItem)
        } 
      }
      this.loader1=false;   
       }else{
         this.loader1=false;
       }
  }, err=>{
    this.loader1 = false;
    this.handler.err(err)  
  })
}

routeToItems(item){
  this.itemtypeObj.map(res=>{
    if(res.id == item.id){
      res.highlight = true;
    }else{
      res.highlight = false;
    }
  })
  this.itemTypeId=item.id;
  sessionStorage.setItem('itemTypeId',this.itemTypeId);
  this.itemtypeObj.sort(function(a, b) {
    return b.highlight - a.highlight 
  })
  this.getService();
 }


  cancel(){
    if(this.url.includes('vendor-order-edit')&& (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))){
      this.router.navigate(['/vendor-request'])
    }else if(this.url.includes('initial-order-edit')&& (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))){
      this.router.navigate(['/manage-Order'])
    }else if(this.url.includes('home-order-edit')&&(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){
      this.router.navigate(['/vendor-manage-order'])
    }else if(this.url.includes('initial-order-edit')&&(this.auth.checkCapability('FSA') ||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))){
      this.router.navigate(['/admin-manage-order'])
    }
    else{
      this.router.navigate(['/requests'])
    }
    
  }

  getCategory() {
    this.service.getOrgCategory().subscribe((res: any) => {
      if(res){
        this.category = res;
        this.category.map(dat=>{
          if(this.id==dat.id){
            this.cateCode=dat.code;
            this.mixedvalue=dat.mixedBooking;
          }
        })
        if(this.mixedvalue==true){
          this.mixedbooking=true;
        }else{
          this.mixedbooking=false;
        }
      }
    })

  }

 


  getCost(data){
    var data1={
      "itemTypeId": this.itemTypeId,
      "region": this.region,
      "serviceId":data.id
    }
    this.service.getCost(data1).subscribe((res:any)=>{
      if(res!=null){
        data.cost= res[0].cost;         
      }else{
        data.cost = data.dfltCost;
        Object.assign(data,{show:true})        
      } 
      data.amtLoader=false;       
    }, err => {    
      this.handler.err(err);
    }) 
  }

  getOrder(id) {
    this.service.getOrderByIdOri(id).subscribe((res: any) => {
      this.cartload = false;
      this.orderItems = res;
      this.matCost = res.materialCost;     
      if (this.orderItems.items) {
        this.storeObj.map(dat => {
          this.orderItems.storeObj.map(dat1 => {
            if (dat.id == dat1.id)
              dat.showQty = dat1.qty;
          })
        })
      }
    }, err => {
      this.cartload = false;
      this.handler.err(err)
       })
  }

 

    addServices(){
      this.addition = true;
      this.loader1=true; 
      if(this.cateCode=="CAR"){
      this.getService();
      }else{
      this.getitemTypeInCreate();
      }
    }

    finish(){
      this.addition = false;
    }

    materialOpen(){
      this.materialpop=true;
    }

    addExtras(){
      this.materialpop=false;
      this.meterialUpdate();
    }

    PlaceOrder(){ 
       this.loader=true;  
          var post={
            orderType:1,
            status:10
          }
          this.service.completeOrder(this.orderId,post).subscribe(res => {
            this.handler.res("Services Added SuccessFully");    
            this.router.navigate(['/vendor-request'])
            this.loader=false; 
          },
            err => {  
              this.loader=false; 
              this.handler.err(err);     
            })
           }


           closeMatPop(){
             this.materialpop=false;
           }
           getOrderById(){
            this.service.getOrderByIdOri(this.orderId).subscribe((res:any) => {
              if (res) {
                localStorage.setItem('shopId',res.orgId)
                this.orderItems = res;
                this.mixvalue =res.itemOrders[0].itemTypeId
                this.id=res.categoryId;
                this.delRegion=res.delRegion
                this.orderEditQty = res.itemOrders;
                this.orderEditQty.map(data=>{
                  Object.assign(data,{created:true,saved:false,edit:false})
                })
                
                this.cartView = true;
                // if(this.cateCode=="CAR"){
                //   this.itemTypeId = this.orderItems.itemOrders[0].itemTypeId;
                //   this.selectItem();
                // }else{
                    if(this.cateCode=="CAR"){
                      this.itemTypeId = this.orderItems.itemOrders[0].itemTypeId;
                      sessionStorage.setItem('itemTypeId',this.itemTypeId)
                    }
                    this.itemTypeId = sessionStorage.getItem('itemTypeId')
                  this.getService();
                if(this.cateCode!="CAR"){
                  this.getitemTypeInCreate();
                }
                this.toploader=false;
                this.loader=false;  
              }else{
                this.toploader=false;
                this.loader=false;
              }
            },
              err => {
                     this.toploader=false;
                     this.loader=false;
                     this.handler.err(err.error)
              })
          }

          getService(){ 
            this.Ind=false; 
            this.service.getAllItemsByCategory(this.id,this.Ind).subscribe((res:any)=>{
             this.storeObj = res;
             this.filterData = res;
             this.storeObj.map(res1=>{
              Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false,amtLoader:true,mixedbook:this.mixedbooking}) 
             }) 
            this.storeObj = this.storeObj.filter(res=>{return res.packageInd == false && res.itemCategoryId==this.id})
            if(this.url.includes('vendor-order-edit') || this.url.includes('contractor-order-edit') || this.url.includes('initial-order-edit')){
              this.storeObj.map(dat=>{
                this.orderEditQty.map(dat1=>{
                  if(dat.id == dat1.itemId){
                    dat.qty = dat1.qty;
                    dat.showQty = dat1.qty;
                    this.showDiv = true;
                  }
                })
              })
            }
            if(this.url.includes('vendor-order-edit') || this.url.includes('contractor-order-edit') || this.url.includes('initial-order-edit')){
              this.getOrder(this.orderId);
              this.storeObj.map(data=>{
                this.getCost(data);
                })
            }
            if((this.url.includes('vendor-order-edit') ||this.url.includes('home-order-edit') || this.url.includes('initial-order-edit')) && this.cateCode!="CAR"){
           
              this.storeObj.map(dat1=>{
                if(dat1.subCost){
                  dat1.subCost.map(dat2=>{
                    if(dat2.itemTypeId==this.itemTypeId){
                      dat1.success = true;
                    }
                  })
                }
              })
              this.storeObj = this.storeObj.filter(dat1=>{return dat1.success})
              this.storeObj.map(data=>{
  
                this.getCost(data);
                  
                })
            } 
          
        if((this.url.includes('vendor-order-edit') || this.url.includes('contractor-order-edit') || this.url.includes('initial-order-edit')) && this.cateCode!="CAR") {
                this.storeObj.map(dat1=>{
                  if(dat1.subCost){
                    dat1.subCost.map(dat2=>{
                      if(dat2.itemTypeId==this.itemTypeId){
                        dat1.success = true;
                      }
                    })
                  }
                })
                this.storeObj = this.storeObj.filter(dat1=>{return dat1.success})
               this.storeObj.map(dat3=>{
                if(dat3.imageId){   
                  this.thumb.getThumbIcon(dat3)
                }
               })
            
               this.loader = false;
               this.toploader=false; 
               this.loader1=false; 
            } 
            
            this.storeObj.map(dat3=>{
              if(dat3.imageId){   
                this.thumb.getThumbIcon(dat3)
              }
            })
            
             this.loader = false;
             this.toploader=false; 
             this.loader1=false;
           },err =>{
             this.handler.err(err)
             this.loader = false; 
             this.toploader=false;
             this.loader1=false;   
           })  
             
          }
          
          addQuantity(data) { 
            this.toploader=true;
            this.showDiv=false;  
              this.storeObj.map(res => {
                if (res != data)
                  res.select = false;
                else
                  res.select = true
              })      
                data.showQty = data.showQty + 1;
                if(data.showQty > 0){
                  this.cartView = true;
                }
                // this.updateOrder();
                if(this.mixvalue == data.subCost[0].itemTypeId || (data.mixedbook==true && this.mixvalue != data.subCost[0].itemTypeId)){
                  this.updateOrder();
                }else{
                  data.showQty=0
                  this.showDiv=true;
                  this.typeConfirmPop=true;
                }    
        }
        updateOrder() {  
          this.showAdd=false;
          let item;
          item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);      
            item.qty = 1;
          let products = {      
            "orderItems" :[
              {
                  "id" : item.id,
                  "qty" :item.qty,
                  "billPostVisit":item.billPostVisit
              }
          ],
          providerServiceId:item.id,
            region:this.delRegion, 
            orderType : 1,
            itemTypeId:this.itemTypeId,
            cnvcChargeApplied:true,
          }
          this.cartload = true;
          this.service.orderItemPost(this.orderId, item.id, products).subscribe((res:any) => {
            if(res){        
              this.cartload = false;
              this.orderItems = res;        
              // if (this.orderItems.items) {
              //   this.storeObj.map(dat => {
              //     this.orderItems.storeObj.map(dat1 => {
              //       if (dat.id == dat1.id)
              //         dat.showQty = dat1.qty;
              //     })
              //   })
              // }
              this.showDiv=true;
              this.showAdd=true;
              this.handler.res('Order updated successfully !!!')
            }
            this.getOrder(this.orderId);
            this.getOrderById();
          },
            err => {
              this.toploader=false;
              this.cartload = false;
                    this.handler.err(err)
            })
        }
        decQuantity(data) { 
          this.showDiv=false; 
          this.toploader=true; 
          this.storeObj.map(res => {
            if (res != data)
              res.select = false;
            else
              res.select = true
          })
             if (data.showQty == 0)
              data.showQty = data.showQty;
            else {
              data.showQty = data.showQty - 1;
              this.updateOrderItem()
            }
        }
        async updateOrderItem(){
          let item;
          item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);
          // item.qty = item.showQty;
          item.qty = 1;
          let products = {      
            "orderItems" :[
              {
                  "id" : item.id,
                  "qty" :item.qty,
                  "billPostVisit":item.billPostVisit
              }
          ],
          providerServiceId:item.id,
            region:this.delRegion, 
            orderType : 1,
            itemTypeId:this.itemTypeId,
            cnvcChargeApplied:true,           
          }  
            this.cartload=true;
            this.service.updateOrderItem(this.orderId, item.id, products).subscribe(res => {
              if(res){
                this.cartload = false;
                this.showDiv=true;
                this.showAdd=true;
                this.orderItems = res;          
                // if (this.orderItems.items) {
                //   this.storeObj.map(dat => {
                //     this.orderItems.storeObj.map(dat1 => {
                //       if (dat.id == dat1.id)
                //         dat.showQty = dat1.qty;
                //     })
                //   })
                // }
                this.handler.res('Order updated successfully !!!')
              }
              this.getOrder(this.orderId);
              this.getOrderById()
             
            },
              err => {
                this.toploader=false;
                this.cartload = false;
                     this.handler.err(err)
              })
          }

          async updateOrderItems(data){
            this.showDiv=false;
            this.showAdd=false;
            this.toploader=true;
            data.qty = data.qty-1;
            let products = {      
             "orderItems" :[
               {
                   "id" : data.itemId,
                   "qty" :data.qty,
                   "billPostVisit":data.billPostVisit
               }
           ],
           providerServiceId:data.itemId,
             region:this.delRegion, 
             orderType : 1,
             itemTypeId:data.itemTypeId,
             cnvcChargeApplied:true
            }
              this.service.updateOrderItem(this.orderId, data.itemId, products).subscribe(res => {
                if(res){
                  this.orderItems = res;
                  this.showDiv=true;
                  this.showAdd=true;
                  this.handler.res('Order updated successfully !!!')
                  this.getOrderById()        
                 } 
              },
                err => {
                       this.toploader=false; 
                       this.handler.err(err)
                })
            }

            updateOrders(data) { 
              this.showDiv=false;
              this.showAdd=false;
              this.toploader=true; 
              data.qty = 1;
              let products = {      
                "orderItems" :[
                  {
                      "id" : data.itemId,
                      "qty" :data.qty,
                      "billPostVisit":data.billPostVisit
                      
                  }
              ],
              providerServiceId:data.itemId,
                region:this.delRegion, 
                orderType : 1,
                itemTypeId:data.itemTypeId,
                cnvcChargeApplied:true
              }
                  this.service.orderItemPost(this.orderId, data.itemId, products).subscribe((res:any) => {
                 if(res){
                   // this.getOrder(this.orderId);
                     this.orderItems = res;        
                     this.getOrderById()
                     this.showDiv=true;
                     this.showAdd=true;
                     this.handler.res('Order updated successfully !!!')
                     }
               },
                 err => {
                         this.toploader=false;
                         this.handler.err(err)
                 })
             }


     meterialUpdate(){
       this.loader=true;
       Object.assign(this.orderItems,{materialCost:this.cost,"cnvcChargeApplied":true})
       this.service.updateOrder(this.orderId,this.orderItems).subscribe(res=>{
        this.cost='' 
        this.getOrderById()
        this.handler.res('Material Cost Added Successfully')
       })
     }
     updateQuantity(data){
       data.created = false;
       data.saved = true;
       data.edit = true;
     }
     saveQuantity(data){
       this.toploader=true;
       data.saved=false;
       data.created=true;
       data.edit = false;
       this.updateBillOrders(data);
     }


     updateBillOrders(data) {  
      let products = {      
        "orderItems" :[
          {
              "id" : data.itemId,
              "qty" :data.qty,
              "billPostVisit":data.billPostVisit
              
          }
      ],
      providerServiceId:data.itemId,
        region:this.delRegion, 
        orderType : 1,
        itemTypeId:data.itemTypeId }
          this.service.getBillByUnit(this.orderId, data.itemId, products).subscribe((res:any) => {
         if(res){
           // this.getOrder(this.orderId);
             this.orderItems = res;        
             this.getOrderById()
             }
       },
         err => {
                 this.toploader=false;
                 this.handler.err(err)
         })
     }
     Stay(){
       this.typeConfirmPop=false;
     }
        
}